'use client';

import { useEffect } from 'react';
import { processMoonshotExperiments } from '@/utils/moonshotExperiments';

const MoonshotAnalytics = () => {
  useEffect(() => {
    const checkForMoonshotData = () => {
      if (window.msaiData?.getAllUserBucketedExperiments) {
        processMoonshotExperiments();
        return true;
      }
      return false;
    };

    if (checkForMoonshotData()) {
      return;
    }

    let attempts = 0;
    const maxAttempts = 5; // Try for 5 seconds (5 * 1000ms)

    const interval = setInterval(() => {
      attempts++;

      if (checkForMoonshotData() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return null;
};

export default MoonshotAnalytics;
